//get my subscription packages
export const GET_MY_SUBSCRIPTION_PACKAGES_REQUEST = "GET_MY_SUBSCRIPTION_PACKAGES_REQUEST";
export const GET_MY_SUBSCRIPTION_PACKAGES_RECEIVE = "GET_MY_SUBSCRIPTION_PACKAGES_RECEIVE";
export const GET_MY_SUBSCRIPTION_PACKAGES_FAILURE = "GET_MY_SUBSCRIPTION_PACKAGES_FAILURE";
export const RESET_GET_MY_SUBSCRIPTION_PACKAGES = "RESET_GET_MY_SUBSCRIPTION_PACKAGES";

//update subscription package
export const UPDATE_SUBSCRIPTION_PACKAGE_REQUEST = "UPDATE_SUBSCRIPTION_PACKAGE_REQUEST";
export const UPDATE_SUBSCRIPTION_PACKAGE_RECEIVE = "UPDATE_SUBSCRIPTION_PACKAGE_RECEIVE";
export const UPDATE_SUBSCRIPTION_PACKAGE_FAILURE = "UPDATE_SUBSCRIPTION_PACKAGE_FAILURE";
export const RESET_UPDATE_SUBSCRIPTION_PACKAGE = "RESET_UPDATE_SUBSCRIPTION_PACKAGE";

//get my subscribers
export const GET_SUBSCRIBERS_REQUEST = "GET_SUBSCRIBERS_REQUEST";
export const GET_SUBSCRIBERS_RECEIVE = "GET_SUBSCRIBERS_RECEIVE";
export const GET_SUBSCRIBERS_FAILURE = "GET_SUBSCRIBERS_FAILURE";
export const RESET_GET_SUBSCRIBERS = "RESET_GET_SUBSCRIBERS";